import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './components/App';

const container = document.getElementById('editorRoot')!;
const root = createRoot(container);
root.render(
    <App/>
);
